import { atom } from 'nanostores';

import { type UserState } from './types';

export const $userStore = atom<UserState>({
  status: 'initializing',
  user: null,
});
